export const TRIP_STATUS_OPTIONS = [
	{ value: '1', label: 'Reported' },
	{ value: '2', label: 'Trip Created' },
	{ value: '4', label: 'Trip Assigned' },
	{ value: '5', label: 'Trip Initiated' },
	{ value: '6', label: 'Trip Started' },
	{ value: '7', label: 'In Transit' },
	{ value: '8', label: 'Delayed' },
	{ value: '9', label: 'Trip Ended' },
	{ value: '3', label: 'Trip Closed' },
];

export const TRIP_CLOSED_STATUS_VALUE = '3';

export const ACTIVE_TRIP_STATUS_OPTIONS = TRIP_STATUS_OPTIONS.filter(
	(option) => option.value !== TRIP_CLOSED_STATUS_VALUE
);
export const TRIP_STATUS_ID = {
	REPORTED: 1,
	CREATED: 2,
	ASSIGNED: 4,
	INITIATED: 5,
	STARTED: 6,
	IN_TRANSIT: 7,
	DELAYED: 8,
	ENDED: 9,
	CLOSED: 3,
};
export const VEHICLE_REPLACEMENT_STATUS_IDS = [
	TRIP_STATUS_ID.CREATED,
	TRIP_STATUS_ID.ASSIGNED,
	TRIP_STATUS_ID.INITIATED,
	TRIP_STATUS_ID.STARTED,
	TRIP_STATUS_ID.IN_TRANSIT,
	TRIP_STATUS_ID.DELAYED,
];

export const DRIVER_REPLACEMENT_STATUS_IDS = [
	TRIP_STATUS_ID.STARTED,
	TRIP_STATUS_ID.IN_TRANSIT,
	TRIP_STATUS_ID.DELAYED,
];

export const DRIVER_DROPDOWN_EDITABLE_STATUS_IDS = [
	TRIP_STATUS_ID.CREATED,
	TRIP_STATUS_ID.ASSIGNED,
	TRIP_STATUS_ID.INITIATED,
];

export const DRIVER_ASSIGN_WHEN_UNASSIGNED_STATUS_IDS = [
	TRIP_STATUS_ID.STARTED,
	TRIP_STATUS_ID.IN_TRANSIT,
	TRIP_STATUS_ID.DELAYED,
	TRIP_STATUS_ID.ENDED,
	TRIP_STATUS_ID.CLOSED,
];
